import apiClient from "./apiClient.js";
import {ADD_USER, CLEAR_USER, DELETE_USER, GET_ALL_USERS, UPDATE_USER, USER_ERROR,} from "./types.js";
import {setAlert} from "./alert";
import {Dispatch} from "redux";
import {History} from "history";
import {CreateUserDto, UpdateUserDto, User, Server} from "@leap4/auth";
import {AlertTypes} from "../utils/alert.utils";
import {errorHandler} from "../utils/error-handler.utils";
import {UserPopulated} from "../models/UserPopulated.model";


export const addUser = (user: CreateUserDto, history: History) => async (dispatch: Dispatch<any>) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const body = JSON.stringify(user);

    try {
        const res = await apiClient.post(Server.routes.USERS.CREATE.path, body, config);
        dispatch({
            type: ADD_USER,
            payload: res.data, //**the data is success message that we get from the response */,
        });

        dispatch(setAlert(` The user ${user.email} has Added successfully!`, AlertTypes.SUCCESS));

        history.push("/users");
    } catch (err) {
        errorHandler(err, dispatch);
        dispatch({
            type: USER_ERROR,
        });
    }
};

export const updateUser =
    (_id: string, user: UpdateUserDto, history: History) => async (dispatch: Dispatch<any>) => {

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        // The request body  - stringify it for prepare the data to send to the server.
        const body = JSON.stringify({
            _id,
            ...user,
        });

        try {
            // Response from the server.
            const res = await apiClient.patch(
                Server.routes.USERS.GET_ONE.populateWithQueryParam([{
                    param: "id",
                    value: _id
                }])/**the endpoint in the server */,
                body,
                config
            );

            dispatch({
                type: UPDATE_USER,
                payload: res.data,
            });

            dispatch(setAlert(`The user ${user.email} has updated succesfuly!`, AlertTypes.SUCCESS));

            // Redirect to users page.
            history.push("/users");
        } catch (err) {
            errorHandler(err, dispatch);
            dispatch({
                type: USER_ERROR,
            });
        }
    };

export const deleteUser = (_id: string) => async (dispatch: Dispatch<any>) => {
    try {
        const res = await apiClient.delete(`${Server.routes.USERS.GET_ONE.path}${_id}`);

        //dispatch for update the users list in the state  in the reducer
        dispatch({type: DELETE_USER, payload: _id});

        dispatch(setAlert("The user removed successfully.", AlertTypes.SUCCESS));
    } catch (err) {
        dispatch({
            type: USER_ERROR,
        });
        dispatch(setAlert("Couldent delete user", AlertTypes.FAILURE));
    }
};

export const clearUser = () => async (dispatch: Dispatch<any>) => {
    try {
        dispatch({type: CLEAR_USER, payload: null});
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {msg: err.message, status: err},
        });
    }
};

export const getAllUsers = () => async (dispatch: Dispatch<any>) => {
    try {
        const populate = [{path: "organization", select: {name: 1}}];

        // Deserialization.
        const res = await apiClient.get(`${Server.routes.USERS.GET_ALL.path}`, {
            params: {
                populate
            }
        });
        const users: UserPopulated[] = res.data.results.map((user: UserPopulated) => User.init(user));

        dispatch({
            type: GET_ALL_USERS,
            payload: users,
        });
    } catch (err) {
        dispatch(setAlert("Error happened", AlertTypes.FAILURE));
    }
};

export const getUserById = async (userId: string, dispatch: Dispatch<any>): Promise<any> => {
    try {
        const res = await apiClient.get(Server.routes.USERS.GET_ONE.populateWithQueryParam([{
            param: "id",
            value: userId
        }]));
        const user = User.init(res.data);

        if (!user) {
            throw new Error("User not found");
        }


        return user;
    } catch (err) {
        const errorMsg = "Couldn't get user"
        dispatch({
            type: USER_ERROR,
            payload: {
                msg: errorMsg,
                status: err.response.status,
            },
        });

        dispatch(setAlert("Couldn't fetch user", AlertTypes.FAILURE));
    }
};


export const IsDataPointAbleToWatchAllSubAccounts = (objDataPoint: any) => {
    // name refactoring - Or ben aba
    if (objDataPoint.nAmountSubAccounts === undefined) {
        return objDataPoint.subAccounts.bIsAbleToWatchAll;
    }
    return (
        objDataPoint.nAmountSubAccounts !== 0 && objDataPoint.nAmountSubAccounts === objDataPoint.accounts.length
    );
};


export const getAllOrganizations = async (dispatch: Dispatch) => {
    try {
        const res = await apiClient.get(Server.routes.ORGANIZATIONS.GET_ALL.path);
        return res.data.results;

    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {
                msg: err.repsonse.statusText,
                status: err.response.status,
            },
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const resendVerificationEmail = (userId: string) => async (dispatch: Dispatch<any>) => {
    try {
        await apiClient.post(`${Server.routes.USERS.GET_ALL.path}/resend-verification`, 
            JSON.stringify({ userId }), 
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        dispatch(setAlert("Verification email sent successfully!", AlertTypes.SUCCESS));
        
        return true;
    } catch (err: any) {
        const errorMessage = err?.response?.data?.message || "Failed to send verification email";
        dispatch(setAlert(errorMessage, AlertTypes.FAILURE));
        
        dispatch({
            type: USER_ERROR,
        });
        
        return false;
    }
};